/* eslint-disable max-len */
import React from 'react';

const ESGLogo: React.FC<{
  color: string;
  product: string;
  margin?: string;
  width?: string;
  height?: string;
}> = ({color, product, margin, width, height}) =>
  product === 'ESG' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '33px'}
      height={height ?? '32px'}
      viewBox={`0 0 ${width ?? '33px'} ${height ?? '32px'}`}
      fill="none"
      style={{margin: margin ?? ''}}
    >
      <g clipPath="url(#clip0_12334_17912)">
        <path
          d="M9.32544 13.0781H16.2761C16.6399 14.3541 17.0876 15.9211 17.6528 17.9022C18.3915 20.4877 19.3989 24.0022 20.8372 29.0445H4.7644C6.20267 24.0022 7.21001 20.4933 7.94873 17.9022C8.51397 15.9267 8.96168 14.3541 9.32544 13.0837V13.0781Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.48602 16.0176H17.1044"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.9624 21.4282H21.8781V15.7031H24.5644L28.1628 21.4282L28.2356 29.0393H21.1674"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.8351 24.7812H25.387"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1862 2.96094C17.457 3.13442 14.5524 3.74443 12.6441 4.99801C10.7637 6.23481 9.92985 8.20473 11.7487 10.0068C12.409 10.6615 13.2597 11.0421 14.0544 11.1092C16.2593 11.3051 17.0092 8.80913 17.5521 7.09665C18.039 5.55765 18.4531 3.95709 19.1862 2.96094Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7487 10.0071C11.7487 10.0071 13.5228 7.2201 16.3545 5.08789"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.521 8.93276L15.2017 8.54102"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8529 7.35795L13.7969 5.125"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58502 19.6875H11.7991"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12334_17912">
          <rect
            width={'32px'}
            height={'32px'}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : product === 'CA' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '33px'}
      height={height ?? '32px'}
      viewBox={`0 0 ${width ?? '33px'} ${height ?? '32px'}`}
      fill="none"
      style={{margin: margin ?? ''}}
    >
      <g clipPath="url(#clip0_12334_17895)">
        <path
          d="M22.5441 23.4878L16.0915 29.4815C15.1625 30.3433 13.7018 30.2873 12.8456 29.3639L7.24924 23.3367C6.10199 22.0999 6.17474 20.1523 7.40594 19.0051L14.9834 11.9648L22.6672 20.2363C23.5291 21.1653 23.4731 22.6259 22.5497 23.4822L22.5441 23.4878Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6081 24.64C15.8788 26.2461 13.1702 26.151 11.5584 24.4161C9.95227 22.6869 10.0474 19.9782 11.7823 18.3665C13.5116 16.7603 16.2202 16.8555 17.8319 18.5903C19.4381 20.3196 19.343 23.0282 17.6081 24.64Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0841 11.8691L24.2118 3.39062L26.5678 5.93137L17.4402 14.4099"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.393 5.08006L21.3353 3.944C20.9267 3.50189 20.9491 2.80794 21.3912 2.39941L21.6039 2.19794C22.046 1.7894 22.74 1.81179 23.1485 2.2539L24.2062 3.38996"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2817 20.0293C17.0988 20.9079 17.0484 22.279 16.1698 23.0961"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.4318 6.93332L24.6147 6.05469"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.0998 8.1716L23.2828 7.29297"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.7959 9.43527L21.9788 8.55664"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.464 10.6716L20.6469 9.79297"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.1041 11.8881L19.287 11.0039"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7721 13.1225L17.9551 12.2383"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12334_17895">
          <rect
            width={'32px'}
            height={'32px'}
            fill={color}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '33px'}
      height={height ?? '32px'}
      viewBox={`0 0 ${width ?? '33px'} ${height ?? '32px'}`}
      fill="none"
      style={{margin: margin ?? ''}}
    >
      <g clipPath="url(#clip0_12334_17926)">
        <path
          d="M20.2552 21.8538L20.2944 27.3662C20.2944 27.8083 19.9362 28.1721 19.4941 28.1777L14.1216 28.2168C13.6795 28.2168 13.3157 27.8587 13.3101 27.4166L13.2709 21.9209C13.0303 20.9416 11.7711 19.5201 11.7711 19.5201C10.6126 18.3057 9.89631 16.6603 9.87953 14.8527C9.85154 11.0808 12.8904 8.00277 16.6623 7.97479C19.7795 7.9524 22.4266 10.0231 23.266 12.8716"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2989 25.3961L20.2776 25.3457"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.358 28.1875C18.3636 29.0437 17.6753 29.7377 16.819 29.7489C15.9628 29.7545 15.2688 29.0661 15.2576 28.2099L18.3524 28.1875H18.358Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.7798 20.8906L16.7966 23.4985"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.89 20.041L16.7854 20.9252"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6584 20.0293L16.7686 20.9303"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6119 2.5293L16.6343 5.15399"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.266 2.25391L21.2793 6.34485"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.719 6.66602L24.1782 8.88777"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.86273 2.3457L11.9054 6.41426"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.47131 6.80469L9.04004 8.98727"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.26459 11.9375L7.52342 12.7434"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.89313 18.1667L7.88158 17.4336"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.415 12.7422H23.2772L23.0086 13.7999C22.74 13.8838 22.4825 13.9902 22.2363 14.1189L21.3017 13.5649L19.7907 15.0759L20.3447 16.0105C20.216 16.2567 20.1097 16.5141 20.0257 16.7828L18.968 17.0514V19.1892L20.0257 19.4578C20.1097 19.7264 20.216 19.9839 20.3447 20.2301L19.7907 21.1647L21.3017 22.6757L22.2363 22.1217C22.4825 22.2504 22.74 22.3567 23.0086 22.4407L23.2772 23.4984H25.415L25.6837 22.4407C25.9523 22.3567 26.2097 22.2504 26.456 22.1217L27.3905 22.6757L28.9016 21.1647L28.3475 20.2301C28.4762 19.9839 28.5826 19.7264 28.6665 19.4578L29.7242 19.1892V17.0514L28.6665 16.7828C28.5826 16.5141 28.4762 16.2567 28.3475 16.0105L28.9016 15.0759L27.3905 13.5649L26.456 14.1189C26.2097 13.9902 25.9523 13.8838 25.6837 13.7999L25.415 12.7422Z"
          stroke={color}
          strokeWidth="0.98"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3573 20.4986C25.6725 20.4986 26.7414 19.4297 26.7414 18.1145C26.7414 16.7994 25.6725 15.7305 24.3573 15.7305C23.0422 15.7305 21.9733 16.7938 21.9733 18.1145C21.9733 19.4353 23.0366 20.4986 24.3573 20.4986Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12334_17926">
          <rect
            width={'32px'}
            height={'32px'}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

export default ESGLogo;
